<template>
  <div>
    <div v-if="model">
        <form class="modern" @submit.prevent="onSubmit()">    
            <div class="bottom">
                <div class="col-12 col-md-8 mt-1">
                    <div class="mb-4">
                        <p class="title-sm"><span v-if="model.id">EDITAR</span> <span v-if="!model.id">NOVA</span> FORMA DE PAGAMENTO</p>
                        <p class="legend-sm"></p>
                    </div>

                    <div class="form-group row">
                        <label class="col-md-2 col-12 col-form-label text-right text-left-mobile">Nome *</label>
                        <div class="col-12 col-md-10">
                            <input type="text" name="name" class="form-control" required="true" 
                            v-model="model.name">
                        </div>
                    </div>
                </div>
            </div>

            <div class="py-3 pr-3 text-right" style="background-color: #f6f6f6;">
              <div v-if="model.id && !areYouSure" class="remove-button-area" @click="remove(model)">
                <i class="fa fa-trash-o"></i>
                <a class="delete-area mr-auto">Excluir</a>
              </div>
              <div v-if="model.id && areYouSure" class="remove-button-area red" @click="removeAgain(model)">
                <i class="fa fa-trash-o"></i>
                <a class="delete-area mr-auto">Toque novamente</a>
              </div>
                <a class="btn btn-secondary pointer text-white" @click="cancel()">Cancelar</a>
                <button class="btn btn-success pointer" :disabled="loading">Salvar</button>            
            </div>
        </form>
    </div>
  </div>
</template>

<script>
  import FinancesPaymentMethod from '@/models/FinancesPaymentMethod'
  import FinancesPaymentMethodService from '@/services/FinancesPaymentMethodService'

  export default {
    data() {
      return {
        payment_methods: [],
        loading: false,
        model: null,
        areYouSure: false
      }
    },
    methods: {
      cancel() {
        this.model = null;
        this.$emit('onCancelled', true)
      },

      changeType(event) {
        if(event == 'r')
          this.load(event)
        else if(event == 'e')
          this.load(event)
      },

      load() {
        FinancesPaymentMethodService.load()
          .then(res => {
            this.payment_methods = res.data
          })
      },
      onSubmit() {
        this.loading = true;

        FinancesPaymentMethodService.createOrUpdate(this.model)
          .then(res => {
            this.loading = false;
            this.cancel()
          })
          .catch(err => {
            this.loading = false;
          })
      },
      open(model) {
        this.model = Object.assign({}, model)
        this.load()
      },
      remove(payment_method) {
        this.areYouSure = true
        setTimeout(() => {
          this.areYouSure = false;
        }, 2000)
      },
      removeAgain(payment_method) {
        FinancesPaymentMethodService.remove(payment_method.id).then(res => {
          this.cancel()
        }).catch(err =>{
          this.cancel()
        })
      }
    },
    mounted() {
      this.load()
    }
  }
</script>
<style>

  .remove-button-area {
    padding: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-left: 20px;
    margin-top: 10px;
    cursor: pointer;
    float: left;
  }
  .remove-button-area > a {
    margin-left: 5px;
  }
  .remove-button-area:hover {
    background-color: #eee;
  }
  .remove-button-area:hover > i {
  }
  .remove-button-area.red{
    color: red;
  }
</style>